/**
 * WorkflowMarkdownPreview — aggregate / 静态 workflow 正文 Markdown 渲染
 *
 * aggregate 节点不走 Agent loop，正文落在 content_blocks.preview（纯文本）；
 * 与 TextNode 的 StreamingMarkdown 对齐，done 态用 RichMarkdown（GFM/表格/代码块）。
 */
import { RichMarkdown } from '../markdown/RichMarkdown';

export interface WorkflowMarkdownPreviewProps {
  content: string;
  testId?: string;
  className?: string;
}

export function WorkflowMarkdownPreview({
  content,
  testId,
  className = 'lax-workflow-markdown-preview',
}: WorkflowMarkdownPreviewProps) {
  if (!content.trim()) return null;
  return (
    <div className={className} data-testid={testId}>
      <RichMarkdown content={content} deferDiagrams />
    </div>
  );
}
